<header *ngIf="topService.isDone" class="guest" [class.zindex]="showAdminNav" [class.guest-header]="!sharedService.isCorpSite">

  <div *ngIf="sharedService.isCorpSite" class="wrapper-header" [class.nav-opened]="navToggle === true">
    <a (click)="clickLogoToReload()">
      <img src="../../assets/images/logo-white-title.svg" width="91" height="24" alt="HUBX" />
    </a>
    <nav class="nav-wrap" [ngClass]="{'mobile-nav': navToggle}">
      <ul (click)="close()" class="nav">
        <li><a [ngClass]="{'activeLink': selectedLink === 'corphome'}" (click)="navigateTo('corphome')">Our Company</a></li>
        <li><a [ngClass]="{'activeLink': selectedLink === 'products'}" (click)="navigateTo('products')" >Products</a></li>
        <li><a [ngClass]="{'activeLink': selectedLink === 'sell'}" (click)="navigateTo('sell')" >Sell On HUBX</a></li>
        <li><a [ngClass]="{'activeLink': selectedLink === 'aboutUs'}"  (click)="navigateTo('aboutUs')">About Us</a></li>
        <li><a [ngClass]="{'activeLink': selectedLink === 'faq'}" (click)="navigateTo('faq')">FAQ</a></li>
        <li><a [ngClass]="{'activeLink': selectedLink === 'contact-support'}" (click)="navigateTo('contact-support')" (click)="navigateTo('contact-support')">Contact</a></li>
      </ul>
      <ul (click)="close()" class="nav buttons">
        <li><a (click)="goToBuyerPortal()" class="buyer-button">Buyer Portal</a></li>
      </ul>
    </nav>
    <div class="toggle-mobile-menu" [class.nav-open]="navToggle === true" (click)="toggleNav()">
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>

  </div>
  <div *ngIf="!sharedService.isCorpSite"
  class="header-inner"
  [class.show-categories]="topService.trendingNavVisible">
    <div class="header-inner__top">
      <div class="header-menu _center-menu">
        <ul class="header-menu-list">
          <li><a [ngClass]="{'activeLink': selectedLink === 'corphome'}" (click)="navigateTo('corphome')">Our Company</a></li>
          <li><a [ngClass]="{'activeLink': selectedLink === 'products'}" (click)="navigateTo('products')" >Products</a></li>
          <li><a [ngClass]="{'activeLink': selectedLink === 'sell'}" (click)="navigateTo('sell')">Sell On HUBX</a></li>
          <li><a [ngClass]="{'activeLink': selectedLink === 'aboutUs'}" (click)="navigateTo('aboutUs')">About Us</a></li>
          <li><a [ngClass]="{'activeLink': selectedLink === 'faq'}" (click)="navigateTo('faq')">FAQ</a></li>
        </ul>
      </div>
    </div>
    <div class="header-inner__btm" [class.search-active]="topService.isSearchActive" (clickOutside)="hideSearch()">
      <div class="header-logo">
        <a class="header-logo__link" (click)="clickLogoToReload()">
          <!-- <img src="assets/images/logo-white-title.svg" width="91" height="24" alt="HUBX" class="_white-title" /> -->
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="91px" height="28px" viewBox="0 0 124 32" enable-background="new 0 0 121 32" xml:space="preserve">
            <path class="rotate-this" fill="#F15B5D" d="M119.143,22.692c-1.205-1.204-2.835-1.696-4.406-1.522c0.126-0.014,0.25-0.024,0.376-0.029
              c-1.127-0.118-2.225-0.626-3.089-1.49c-0.877-0.877-1.391-1.988-1.497-3.136c-0.005,0.16-0.018,0.319-0.037,0.479
              c0.194-1.591-0.296-3.249-1.517-4.47c-0.915-0.915-2.085-1.432-3.283-1.546c-0.005-0.004-0.009-0.008-0.014-0.004
              c-0.25,0.013-0.491,0.009-0.732-0.021c-1.127-0.119-2.225-0.606-3.089-1.47c-0.878-0.877-1.369-1.987-1.475-3.136
              c-0.005-0.013-0.005-0.021,0-0.034c-0.021-0.191-0.03-0.395-0.021-0.598c-0.098-1.225-0.618-2.424-1.555-3.36
              c-2.106-2.106-5.521-2.105-7.627,0c-2.106,2.106-2.106,5.521,0,7.627c0.911,0.911,2.076,1.432,3.263,1.55
              c0.013-0.004,0.025,0,0.033,0c0.25,0.03,0.5,0.034,0.75,0.021h0.025c1.114,0.123,2.208,0.614,3.063,1.47
              c0.848,0.848,1.335,1.919,1.462,3.03c-0.013,0.284-0.008,0.568,0.03,0.843c-0.009,0.008-0.005,0.013-0.005,0.021
              c0.127,1.178,0.645,2.331,1.547,3.233c1.225,1.225,2.891,1.715,4.485,1.515c-0.139,0.018-0.269,0.029-0.407,0.036
              c1.114,0.123,2.201,0.636,3.058,1.491c0.847,0.848,1.355,1.92,1.482,3.029c0.008-0.139,0.021-0.275,0.039-0.414
              c-0.209,1.603,0.28,3.28,1.513,4.512c2.105,2.106,5.521,2.106,7.627,0C121.248,28.213,121.248,24.799,119.143,22.692"/>
            <path class="rotate-this" fill="#F15B5D" d="M91.177,22.692c2.105-2.106,5.521-2.106,7.627,0c2.105,2.106,2.105,5.521,0,7.627
              c-2.106,2.106-5.521,2.106-7.627,0C89.07,28.213,89.07,24.799,91.177,22.692"/>
            <path class="rotate-this" fill="#F15B5D" d="M111.516,2.354c2.105-2.106,5.521-2.106,7.627,0c2.105,2.106,2.105,5.521,0,7.627
              c-2.106,2.106-5.521,2.106-7.627,0C109.409,7.875,109.409,4.46,111.516,2.354"/>
            <path fill="#fff" d="M18.63,7.601H7.266v-7.702H0.279v32h6.987V14.589h10.647v17.311H24.9V13.872
              C24.9,10.472,22.029,7.601,18.63,7.601"/>
            <path fill="#fff" d="M47.687,7.601v17.311H37.038V7.601h-6.987v18.027c0,3.458,2.813,6.271,6.271,6.271h12.08
              c3.458,0,6.271-2.813,6.271-6.271V7.601H47.687z"/>
            <path fill="#fff" d="M78.175,7.601H66.811v-7.702h-6.987v32h18.351c3.458,0,6.271-2.813,6.271-6.271V13.872
              C84.446,10.414,81.633,7.601,78.175,7.601 M66.811,14.589H77.46v10.323H66.811V14.589z"/>
        </svg>
        </a>
      </div>
      <div class="header-menu _left-menu">
        <ul class="header-menu-list">
          <!-- Categories menu -->
          <li class="categories-menu">
            <a [class.disabled]="topService.loading"  (click)="toggleCategories(true)">
              <i class="_icon">
                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m5.63073076 9.69375c1.22102099.12285 2.1424133 1.1331 2.1424133 2.349675 0 1.1169-.80181364 2.090025-1.90643866 2.314125-.15686176.032175-.31849756.048375-.48013337.048375s-.32327162-.0162-.48036071-.048375c-1.10462502-.2241-1.90621132-1.19745-1.90621132-2.3139 0-1.216575.92139231-2.22705 2.14332264-2.3499.15868044-.01665.32668165-.01665.48740812 0zm-.24415873-6.69375c1.31604738 0 2.38657203 1.059525 2.38657203 2.361825 0 1.30275-1.07052465 2.3625-2.38657203 2.3625-1.31604739 0-2.38657203-1.05975-2.38657203-2.3625 0-1.3023 1.07052464-2.361825 2.38657203-2.361825zm0 13.2759c1.31604738 0 2.38657203 1.05975 2.38657203 2.36205s-1.07052465 2.36205-2.38657203 2.36205c-1.31604739 0-2.38657203-1.05975-2.38657203-2.36205s1.07052464-2.36205 2.38657203-2.36205zm6.85758667-6.58215c1.2207937.12285 2.1424133 1.1331 2.1424133 2.349675 0 1.1169-.8018136 2.090025-1.9064386 2.314125-.1568618.032175-.3184976.048375-.4801334.048375s-.3232716-.0162-.4803607-.048375c-1.1043977-.2241-1.90621133-1.19745-1.90621133-2.3139 0-1.216575.92139233-2.22705 2.14332263-2.3499.1586805-.01665.3266817-.01665.4874081 0zm-.2441587-6.69375c1.3158201 0 2.386572 1.059525 2.386572 2.361825 0 1.30275-1.0707519 2.3625-2.386572 2.3625-1.3160474 0-2.38657203-1.05975-2.38657203-2.3625 0-1.3023 1.07052463-2.361825 2.38657203-2.361825zm0 13.2759c1.3158201 0 2.386572 1.05975 2.386572 2.36205s-1.0707519 2.36205-2.386572 2.36205c-1.3160474 0-2.38657203-1.05975-2.38657203-2.36205s1.07052463-2.36205 2.38657203-2.36205zm6.8575867-6.58215c1.221021.12285 2.1424133 1.1331 2.142186 2.349675 0 1.1169-.8018137 2.090025-1.9062114 2.314125-.1568617.032175-.3187249.048375-.4803607.048375s-.3234989-.0162-.4803607-.048375c-1.104625-.2241-1.9062113-1.19745-1.9062113-2.3139 0-1.216575.9216197-2.22705 2.14355-2.3499.1579984-.016425.3273636-.016425.4874081 0zm-.2441587-1.969425c-1.3158201 0-2.3865721-1.05975-2.3865721-2.3625 0-1.3023 1.070752-2.361825 2.3865721-2.361825 1.31582 0 2.386572 1.059525 2.386572 2.361825 0 1.30275-1.070752 2.3625-2.386572 2.3625zm0 8.551575c1.31582 0 2.386572 1.05975 2.386572 2.36205s-1.070752 2.36205-2.386572 2.36205c-1.3158201 0-2.3865721-1.05975-2.3865721-2.36205s1.070752-2.36205 2.3865721-2.36205z" fill="#FFFFFF" fill-rule="evenodd" stroke="none" stroke-width="1"></path></svg>
              </i>
              <span class="categories-span">Categories</span>
            </a>
          </li>
          <li>
            <a (click)="clickLogoToReload()">
              <i class="_icon">
                <img src="assets/images/icons/header/home-white.svg" width="24" height="24" alt="Home">
              </i>
              <span class="home-label">Home</span>
            </a>
          </li>
          <li>
            <a [ngClass]="{'activeLink': selectedLink === 'guest/outlets'}" (click)="navigateToOutlets('guest/outlets')">
              <i class="_icon">
                <img src="assets/images/icons/header/outlets-white.svg" width="24" height="24" alt="Outlets">
              </i>
              <span class="outlets-label">Outlets</span>
            </a>
          </li>
               <!-- Past Purchases -->
        <li>
          <a
          (click)="pastPurchaseCliked()"
          [routerLink]="['/guest/past_purchases']"
          routerLinkActive="active"
          [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/header/past-purchase-white.svg" width="24" height="24" alt="Past Purchase">
            </i>
            <span class="past-purchase-label">Past Purchase</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="topService.loading" (click)="ShowGuestPopUp()">
            <i class="_icon">
              <img *ngIf="!isExporting" src="assets/images/icons/header/price-list-white.svg" width="24" height="24" alt="Price List">
              <i *ngIf="isExporting" class="loader"></i>
            </i>
            <span class="price-label">Price List</span>
          </a>
        </li>
        <!-- Notifications center -->
        <li class="notif-bell">
          <a [routerLink]="['/guest/notifications']" routerLinkActive="active" [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/rebranding/header-bell.svg" width="24" height="24" alt="Notification">
            </i>
            <span class="_badge-notification" *ngIf="newNotificationCounter > 0">{{newNotificationCounter}}</span>
            <span class="notif-label">Notifications</span>
          </a>
        </li>
        <!-- Offer Notifications -->
        <li>
          <a [routerLink]="['guest/offers']" routerLinkActive="active" [class.disabled]="topService.loading" [style.pointer-events]="user_role === 'GUEST' ? 'none' : ''">
            <i class="_icon">
              <img src="assets/images/icons/rebranding/offers-header.svg" width="24" height="24" alt="Offer Notifications">
            </i>
            <span class="_badge-new">
              NEW
            </span>
            <span class="notif-label __offers">My Offers</span>
          </a>
        </li>
          <li>
            <a [ngClass]="{'activeLink': selectedLink === 'guest/auctions'}" (click)="navigateToAuctions('guest/auctions')">
              <i class="_icon __auctions">
                <svg *ngIf="auctionService.itemsReady && auctionService.liveAuctionCounter>0" class="icon-glow" height="24"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                   <circle cx="12" cy="12" fill-rule="evenodd" fill="#B4F397" r="5"/>
                 </svg>
                 <svg [ngClass]="{'_green-dot': auctionService.itemsReady && auctionService.liveAuctionCounter>0,
                 '_red-dot': auctionService.itemsReady && auctionService.liveAuctionCounter<1}" height="24"
                  viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                   <circle cx="12" cy="12" fill-rule="evenodd" r="5"/></svg>
              </i>
              <span class="auctions-span">Live Auctions</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="header-menu _search">
        <div class="search-box">
          <button [disabled]="isSearchEmpty()" (click)="searchItems(topSearch.value)" class="searchButton">
            <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m25.84375 22.8029159-4.4166667-4.4727935c.71875-1.2548816 1.09375-2.6503515 1.09375-4.0562354 0-4.56131215-3.7083333-8.273887-8.2604166-8.273887-4.55208337 0-8.2604167 3.71257485-8.2604167 8.273887 0 4.5613122 3.70833333 8.273887 8.2604167 8.273887 1.453125 0 2.890625-.4009372 4.171875-1.1663629l4.3958333 4.4571726c.0989583.0989326.2395833.1614163.3802083.1614163s.28125-.0572768.3802084-.1614163l2.2552083-2.2806561c.2083333-.213486.2083333-.5467326 0-.7550117zm-11.5833333-13.57979692c2.78125 0 5.0416666 2.26503512 5.0416666 5.05076802s-2.2604166 5.050768-5.0416666 5.050768-5.0416667-2.2650351-5.0416667-5.050768 2.2604167-5.05076802 5.0416667-5.05076802z" fill="#fff"/></svg>
          </button>
          <input [disabled]='searchDisabled()' #topSearch
            type="text" ng-keyup="$event.keyCode == 13 && searchItems()"
            class="searchTerm"
            placeholder="Search" [(ngModel)]="topService.searchString"
            (keyup)="isKeyEnter($event, topSearch.value)">
          <div class="search-close" title="Close search" (click)="hideSearch()">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="delete/white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Shape" fill="#FFFFFF" fill-rule="nonzero" points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"></polygon>
                </g>
            </svg>
          </div>
        </div>
    </div>
      <div class="header-menu _right-menu">
        <ul class="header-menu-list" (click)="close()">
          <li>
            <a class="search-link" (click)="showSearch()">
              <i class="_icon">
                <img src="assets/images/icons/header/search-white.svg" width="32" height="32" alt="Search">
              </i>
            </a>
          </li>
          <li><a role="button" class="become-customer-link-vendor" (click)="ShowGuestPopUp()">Vendor Sign Up</a></li>
          <li><a role="button" class="become-customer-link-buyer" (click)="ShowGuestPopUp()">Buyer Sign Up</a></li>
        </ul>
      </div>
    </div>
  </div>

</header>
<!-- END OF HEADER -->


<div *ngIf="topService.isDone && !sharedService.isCorpSite && !sharedService.isVendorLoginUrl">
  <app-top-categories></app-top-categories>
</div>

  <app-dropdown-categories  (close)="toggleCategories($event)"  *ngIf="isCategoriesOpened"></app-dropdown-categories>
